import * as React from 'react';
import styled from 'styled-components';
import { KEYCODES } from '../../consts';

type Props = {
    value?: string;
    onSave?: (value: string, openNewTagAfterSave?: boolean) => void;
};

export const Input = styled.input`
    border: none;
    outline: none;
    height: 2em;
    vertical-align: middle;
    margin: 0.25em;
    font-size: 1em;

    &:focus,
    &:active {
        outline: none;
    }
`;

const transformChange = (value: string) => value.replace(/[^a-zA-Z0-9, ]/g, '');

export default ({ value = '', onSave }: Props) => {
    const [text, setText] = React.useState(value);
    const ref = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (ref && ref.current !== null) {
            ref.current.focus();
        }
    }, [ref]);

    return (
        <Input
            ref={ref}
            type="text"
            value={`#${text}`}
            onChange={e => {
                const newText = transformChange(e.target.value.slice(1));
                setText(newText);
            }}
            onKeyUp={e => {
                if (onSave && [KEYCODES.SPACE, KEYCODES.ENTER, KEYCODES.COMMA].includes(e.keyCode)) {
                    onSave(text, true);
                    setText('');
                }
                if (onSave && e.keyCode === KEYCODES.ESCAPE) {
                    onSave('');
                }
                e.stopPropagation();
            }}
            onBlur={() => {
                if (onSave) {
                    onSave(text);
                }
            }}
        />
    );
};
